<tree-view class="no-scroll" [viewMetadata]="viewMetadata" [entities]="entities" [datacontroller]="datacontroller">
</tree-view>

